import { authState } from './auth.js';

/**
 * Get the discord-bot API base URL, read from PUBLIC_API_URL at build time
 * (inlined by Bun via `env: 'PUBLIC_*'` in build.js / dev-server.js).
 * @returns {string}
 */
export function getBackendUrl() {
    return process.env.PUBLIC_API_URL || '';
}

class ApiClient {
    constructor() {
        this.baseUrl = getBackendUrl();
    }

    async fetch(path, options = {}) {
        const url = `${this.baseUrl}${path}`;
        const headers = new Headers(options.headers || {});

        try {
            const token = await authState.getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
        } catch {
            // Not authenticated
        }

        if (!headers.has('Content-Type') && options.body && typeof options.body === 'string') {
            headers.set('Content-Type', 'application/json');
        }

        return fetch(url, { ...options, headers });
    }

    async get(path) {
        const response = await this.fetch(path);
        if (!response.ok) {
            throw new Error(`API error: ${response.status} ${response.statusText}`);
        }
        return response.json();
    }

    async post(path, data) {
        const options = { method: 'POST' };
        if (data) options.body = JSON.stringify(data);
        const response = await this.fetch(path, options);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
                errorData.message || `API error: ${response.status} ${response.statusText}`,
            );
        }
        return response.json();
    }

    async put(path, data) {
        const options = { method: 'PUT' };
        if (data) options.body = JSON.stringify(data);
        const response = await this.fetch(path, options);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
                errorData.message || `API error: ${response.status} ${response.statusText}`,
            );
        }
        return response.json();
    }

    async delete(path) {
        const response = await this.fetch(path, { method: 'DELETE' });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
                errorData.message || `API error: ${response.status} ${response.statusText}`,
            );
        }
    }
}

export const api = new ApiClient();
